function DateFormat(date) {
  const d = new Date(date);
  const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"];
  const day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();

  return `${day} ${month[d.getMonth()]} ${d.getFullYear()}`;
}

export default DateFormat;
